module.exports = __webpack_public_path__ + "54aee0f52dd50e96d41ae87c8b73e467.svg";